import {
    type UseFeatureFlag,
    type UseRawFeatureFlag,
    usePostHogFeatureFlag,
    useRawPostHogFeatureFlag
} from '@components/PostHogProvider';

export const useFeature: UseFeatureFlag = (flag, defaultValue = false) => {
    return usePostHogFeatureFlag(flag, defaultValue);
};

export const useRawFeature: UseRawFeatureFlag = (flag) => {
    const result = useRawPostHogFeatureFlag(flag);
    return result;
};

export default useFeature;
